import * as React from 'react'
import { trackingContext, TrackingContext } from './context'

export { type TrackingContext } from './context'

export function useTracking(): TrackingContext {
  const context = React.useContext(trackingContext)
  return context
}
